import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'Phone',
      title: 'Call Us',
      primary: '(555) 123-4567',
      secondary: 'Mon-Fri: 8AM-8PM, Sat-Sun: 9AM-6PM',
      action: () => window.location.href = 'tel:+15551234567',
      color: 'text-primary'
    },
    {
      icon: 'Mail',
      title: 'Email Us',
      primary: 'hello@clean360.com',
      secondary: 'We respond within 24 hours',
      action: () => window.location.href = 'mailto:hello@clean360.com',
      color: 'text-accent'
    },
    {
      icon: 'MessageSquare',
      title: 'WhatsApp',
      primary: 'Chat with us instantly',
      secondary: 'Available 24/7 for quick questions',
      action: () => window.open('https://wa.me/15551234567?text=Hi Clean360! I need help with cleaning services.', '_blank'),
      color: 'text-success'
    },
    {
      icon: 'MapPin',
      title: 'Visit Us',
      primary: '123 Clean Street, Suite 100',
      secondary: 'Downtown Business District',
      action: () => window.open('https://maps.google.com?q=123+Clean+Street+Suite+100', '_blank'),
      color: 'text-warning'
    }
  ];

  const businessHours = [
    { day: 'Monday - Friday', hours: '8:00 AM - 8:00 PM' },
    { day: 'Saturday', hours: '9:00 AM - 6:00 PM' },
    { day: 'Sunday', hours: '9:00 AM - 6:00 PM' },
    { day: 'Emergency Service', hours: '24/7 Available' }
  ];

  const serviceAreas = [
    'Downtown District',
    'Residential Heights',
    'Business Park',
    'Suburban Communities',
    'Industrial Zone',
    'University Area'
  ];

  const handleEmergencyCall = () => {
    window.location.href = 'tel:+15551234567';
  };

  const handleWhatsAppChat = () => {
    const message = encodeURIComponent('Hi Clean360! I have an urgent cleaning emergency and need immediate assistance.');
    window.open(`https://wa.me/15551234567?text=${message}`, '_blank');
  };

  return (
    <div className="space-y-6">
      {/* Emergency Contact */}
      <div className="bg-error/10 border border-error/20 rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-10 h-10 bg-error rounded-lg flex items-center justify-center">
            <Icon name="AlertTriangle" size={20} color="white" />
          </div>
          <div>
            <h3 className="font-semibold text-error">Emergency Service</h3>
            <p className="text-sm text-error/80">Available 24/7</p>
          </div>
        </div>
        <p className="text-sm text-error/80 mb-4">
          For water damage, flooding, or urgent cleaning emergencies
        </p>
        <div className="grid grid-cols-2 gap-3">
          <Button
            variant="outline"
            onClick={handleEmergencyCall}
            iconName="Phone"
            iconPosition="left"
            className="border-error text-error hover:bg-error hover:text-white"
          >
            Call Now
          </Button>
          <Button
            variant="outline"
            onClick={handleWhatsAppChat}
            iconName="MessageSquare"
            iconPosition="left"
            className="border-error text-error hover:bg-error hover:text-white"
          >
            WhatsApp
          </Button>
        </div>
      </div>
      {/* Contact Methods */}
      <div className="bg-white rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Get In Touch
        </h3>
        <div className="space-y-4">
          {contactMethods?.map((method, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-4 rounded-lg hover:bg-muted transition-colors duration-200 cursor-pointer"
              onClick={method?.action}
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center bg-muted ${method?.color}`}>
                <Icon name={method?.icon} size={20} />
              </div>
              <div className="flex-1">
                <h4 className="font-medium text-text-primary">{method?.title}</h4>
                <p className="text-sm text-text-primary font-medium">{method?.primary}</p>
                <p className="text-xs text-text-secondary">{method?.secondary}</p>
              </div>
              <Icon name="ExternalLink" size={16} color="var(--color-text-secondary)" />
            </div>
          ))}
        </div>
      </div>
      {/* Business Hours */}
      <div className="bg-white rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Business Hours
        </h3>
        <div className="space-y-3">
          {businessHours?.map((schedule, index) => (
            <div key={index} className="flex justify-between items-center py-2">
              <span className="text-sm text-text-secondary">{schedule?.day}</span>
              <span className={`text-sm font-medium ${
                schedule?.day === 'Emergency Service' ? 'text-error' : 'text-text-primary'
              }`}>
                {schedule?.hours}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* Service Areas */}
      <div className="bg-white rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Service Areas
        </h3>
        <div className="grid grid-cols-2 gap-2">
          {serviceAreas?.map((area, index) => (
            <div key={index} className="flex items-center space-x-2 py-1">
              <Icon name="MapPin" size={14} color="var(--color-primary)" />
              <span className="text-sm text-text-secondary">{area}</span>
            </div>
          ))}
        </div>
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-xs text-text-secondary">
            Don't see your area? Contact us to check availability in your location.
          </p>
        </div>
      </div>
      {/* Quick Actions */}
      <div className="bg-white rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Quick Actions
        </h3>
        <div className="space-y-3">
          <Button
            variant="outline"
            fullWidth
            iconName="Calendar"
            iconPosition="left"
            onClick={() => console.log('Book service clicked')}
          >
            Schedule Service
          </Button>
          <Button
            variant="outline"
            fullWidth
            iconName="Calculator"
            iconPosition="left"
            onClick={() => console.log('Get quote clicked')}
          >
            Get Instant Quote
          </Button>
          <Button
            variant="outline"
            fullWidth
            iconName="FileText"
            iconPosition="left"
            onClick={() => console.log('View services clicked')}
          >
            View All Services
          </Button>
        </div>
      </div>
      {/* Social Proof */}
      <div className="bg-white rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Why Choose Clean360?
        </h3>
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center">
              <Icon name="Star" size={16} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">4.9/5 Rating</p>
              <p className="text-xs text-text-secondary">From 500+ reviews</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name="Shield" size={16} color="var(--color-primary)" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">Fully Insured</p>
              <p className="text-xs text-text-secondary">$2M liability coverage</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-accent/10 rounded-lg flex items-center justify-center">
              <Icon name="Clock" size={16} color="var(--color-accent)" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">Same-Day Service</p>
              <p className="text-xs text-text-secondary">Available for emergencies</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-warning/10 rounded-lg flex items-center justify-center">
              <Icon name="Award" size={16} color="var(--color-warning)" />
            </div>
            <div>
              <p className="text-sm font-medium text-text-primary">Certified Team</p>
              <p className="text-xs text-text-secondary">Trained professionals</p>
            </div>
          </div>
        </div>
      </div>
      {/* Map */}
      <div className="bg-white rounded-lg shadow-elevation-1 p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4">
          Our Location
        </h3>
        <div className="w-full h-48 rounded-lg overflow-hidden">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="Clean360 Office Location"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=40.7128,-74.0060&z=14&output=embed"
            className="border-0"
          />
        </div>
        <div className="mt-3 text-center">
          <Button
            variant="outline"
            size="sm"
            iconName="Navigation"
            iconPosition="left"
            onClick={() => window.open('https://maps.google.com?q=40.7128,-74.0060', '_blank')}
          >
            Get Directions
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;